import { WIDGET_FORM_INPUT_COLOR } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const ColorInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_COLOR,
  component: () => import("./color-form-input-widget.component").then((m) => m.ColorFormInputWidgetComponent)
};
